import { useState, useEffect } from "react";
import { useFormik } from "formik";
import PlatformDefaultsForm from "@serie3/mymediaplanner/Modules/Social/Forms/PlatformDefaultsForm";
import crudApi from "@serie3/common/api/crudApi";
import SocialEndpoints from "@serie3/mymediaplanner/Modules/Social/endpoints";
import { PlatformFormLayout } from "./PlatformFormShared";

const PlatformDefaults = () => {
  const [activeKey, setActiveKey] = useState("youtube");
  const formik = useFormik(PlatformDefaultsForm.createPlatformDefaultsForm());

  useEffect(() => {
    const load = async () => {
      const response = await crudApi.justGet(SocialEndpoints.settings.platformDefaults);
      if (response.ok && response.data) {
        formik.setValues(PlatformDefaultsForm.setEditData(response.data));
      }
    };
    load();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PlatformFormLayout
      formik={formik}
      activeKey={activeKey}
      setActiveKey={setActiveKey}
      onSubmit={formik.handleSubmit}
      saveLabel="Save Defaults"
    />
  );
};

export default PlatformDefaults;
